import { BadgeCheck } from "lucide-react";

export function VerifiedBadge({ className = "w-4 h-4" }) {
  return (
    <span title="Verified Candidate — photo, resume & approved video" data-testid="verified-badge" className="inline-flex">
      <BadgeCheck className={`${className} text-[#2E7D5B] fill-[#DDF0E6]`} />
    </span>
  );
}
